/** Identifiants des thèmes Manewco (`index.tsx`), repris par la bascule du menu. */
export const MANEWCO_THEME_ID = 'manewco';
export const MANEWCO_DARK_THEME_ID = 'manewco-dark';
